import { useQueryParams } from './useQueryParams'

export const useQueryParamsReset = () => {
  const [,,, reset] = useQueryParams()

  return reset
}
